import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'licensePlateMask'
})
export class LicensePlateMaskPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      if(value.length === 7) {
        var x1: string = value.slice(0, 3);
        var x2: string = value.slice(3, value.length);
        value = x1 + "-" + x2;
      }
      
      return value;
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/license-plate-mask.pipe.ts
 **/